export class LetterResult {
    authIntakeNotificationId!: number;
    letterGuid!: string;
    faxLetterQueueCreated!: boolean;
    message!: string;
}